// ToastHost — REFORMA E3a (monit 1207R zad. 11/12): wyświetla toasty z shared/toastBus.js
// (dół ekranu, tap = zamknięcie, auto po `ms`). Montowany RAZ w main.jsx obok <App/>.

import { useEffect, useState } from "react";
import { subscribeToasts } from "../../shared/toastBus.js";
import { TOKENS } from "../../shared/tokens.js";

const KIND_STYLE = {
  info:  { border: "rgba(var(--fo-ink, 255,255,255), 0.35)", color: "#fff" },
  ok:    { border: "#22c55e", color: "#fff" },
  warn:  { border: "#eab308", color: "#fff" },
  error: { border: "var(--fo-red, #ef4444)", color: "#fff" },
};

export default function ToastHost() {
  const [toasts, setToasts] = useState([]);
  useEffect(() => subscribeToasts((t) => {
    setToasts((prev) => [...prev.slice(-2), t]);
    setTimeout(() => setToasts((prev) => prev.filter((x) => x.id !== t.id)), t.ms);
  }), []);
  if (!toasts.length) return null;
  return (
    <div data-toast-host="1" style={{
      position: "fixed", left: 12, right: 12, bottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
      zIndex: 1500, display: "flex", flexDirection: "column", gap: 8, maxWidth: 560, margin: "0 auto",
      pointerEvents: "none",
    }}>
      {toasts.map((t) => {
        const k = KIND_STYLE[t.kind] || KIND_STYLE.info;
        return (
          <div
            key={t.id}
            role="status"
            data-toast-kind={t.kind}
            onClick={() => setToasts((prev) => prev.filter((x) => x.id !== t.id))}
            style={{
              pointerEvents: "auto", cursor: "pointer",
              padding: "11px 14px", borderRadius: 12, fontSize: 13.5, fontWeight: 600, lineHeight: 1.4,
              background: "rgba(16,16,18,0.96)", color: k.color, border: `1px solid ${k.border}`,
              boxShadow: "0 8px 24px rgba(0,0,0,0.5)", fontFamily: TOKENS.font.sans,
            }}
          >
            {t.text}
          </div>
        );
      })}
    </div>
  );
}
